import {
  carHouseAdmins,
  createCarHouseAdmin,
  updateCarHouseAdmin,
  deleteCarHouseAdmin,
} from '../../lib/carHouseAdmin';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getCarHouseAdmins = createAsyncThunk(
  'carHouseAdmin/getCarHouseAdmins',
  async ({carHouseId, options = {} }) => {
    const data = await carHouseAdmins(carHouseId, options);
    return data;
  }
);

export const addCarHouseAdmin = createAsyncThunk(
  'carHouseAdmin/addCarHouseAdmin',
  async ({carHouseId, body}, { rejectWithValue }) => {
    try {
      const data = await createCarHouseAdmin(carHouseId, body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editCarHouseAdmin = createAsyncThunk(
  'carHouseAdmin/editCarHouseAdmin',
  async ({ carHouseId, carHouseAdminId, body }, { rejectWithValue }) => {
    try {
      const response = await updateCarHouseAdmin(
        carHouseId,
        carHouseAdminId,
        body
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const removeCarHouseAdmin = createAsyncThunk(
  'carHouseAdmin/removeCarHouseAdmin',
  async ({carHouseId, carHouseAdminId}) => {
    const data = await deleteCarHouseAdmin(carHouseId, carHouseAdminId);
    return data;
  }
);
